import { ArtsApiRemoteService } from '../../Services/api/arts/arts-service'
import { IArtEntity } from '../../Services/api/arts/arts.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowArtsUseCase
implements IFormUsecase<string, IArtEntity | undefined> {
  constructor (private readonly ArtsApi: ArtsApiRemoteService) {}
    

  public async handle (
    boxId: string
  ): Promise<Result<IArtEntity | undefined>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ArtsApi.show(boxId)

      if (response.isFailure) {
        return response
      }
    
      const show = response.getValue()

      if(!show) return response
    
      return Result.ok(show)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
